export enum MitigationDays {
  SevenDays = 0,
  OneMonth = 1,
  ThreeMonths = 2,
  MoreThanThreeMonths = 3,
  TwelveMonths = 4,
  TwentyFourMonths = 5,
  MoreThanTwentyFourMonths = 6,
}
